import { render, staticRenderFns } from "./ComplianceReports.vue?vue&type=template&id=356307bc"
import script from "./ComplianceReports.vue?vue&type=script&lang=js"
export * from "./ComplianceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports